import { render, staticRenderFns } from "./TwoFactorRequirement.vue?vue&type=template&id=48b407ec&scoped=true&"
import script from "./TwoFactorRequirement.vue?vue&type=script&lang=js&"
export * from "./TwoFactorRequirement.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactorRequirement.vue?vue&type=style&index=0&id=48b407ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b407ec",
  null
  
)

export default component.exports